'use strict';
var angular = require('angular');
var Promise = require('bluebird');
// Configure
Promise.config({
    longStackTraces: true,
    warnings: true
});

module.exports = function (Department, $translate) {

    var form = {
        addPage: function () {
            if (!this.pages) {
                this.pages = [];
            }

            this.pages.push({
                id: Math.random().toString(36).substr(2, 9),
                requires: [],
                fields: [],
                type: 'page'
            });
        },
        removePage: function (index) {
            if (this.pages.length < 2) {
                return;
            }
            this.pages.splice(index, 1);
        },
        movePage: function(index, direction) {
            // console.log('this.pages', this.pages);
            // console.log('index', index);
            // console.log('direction', direction);

            // Calculate the new index
            const newIndex = index + direction;
            // console.log('newIndex', newIndex);
        
            // Check if the new index is within the array bounds
            if (newIndex >= 0 && newIndex < this.pages.length) {
                // Swap the elements
                const temp = this.pages[index];
                this.pages[index] = this.pages[newIndex];
                this.pages[newIndex] = temp;
                // console.log('this.pages modificado', this.pages);
            }
        },
        save: function (departmentId) {
            var _this = this;
            if (!departmentId) {
                return Promise.reject(new Error($translate.instant("DASHBOARD.DASH_BUILDER.FORM_FACTORY.SAVE_ERR_DEPTO")));
            }
            if (!this.name) {
                // || !this.description
                // return Promise.reject(new Error($translate.instant("DASHBOARD.DASH_BUILDER.FORM_FACTORY.SAVE_ERR_NAME_DESC")));
                return Promise.reject(new Error($translate.instant("DASHBOARD.DASH_BUILDER.FORM_FACTORY.SAVE_ERR_NAME")));
            }

            if (this.id) {
                var id = this.id;

                delete this.id;
                delete this.departmentId;
                delete this.tenantId;
                delete this.$promise;
                delete this.$resolved;
                return Department.forms.updateById({
                        id: departmentId,
                        fk: id
                    }, this)
                    .$promise.then(function () {
                        _this.id = id;
                        return _this;
                    })
                    // this.$save();
            }

            return Department.forms.create({
                        id: departmentId
                    },
                    this)
                .$promise;
        },
        destroy: function () {
            return Department.forms.destroyById({
                    id: this.departmentId,
                    fk: this.id
                },
                this).$promise;
        },
        removeElement: function (id) {
            function removeInnerArray(fields,id){
                fields.forEach(function (element, index) {
                        if(element.id==id){
                            fields.splice(index,1);
                        }else if(element.nodes && element.nodes.length>0)
                            removeInnerArray(element.nodes,id);
                            
                });

            }
            this.pages.forEach(function (page) {
                removeInnerArray(page.fields,id);
            });
        },
        cloneElement: function (id) {
            let idMappings = {}; // Object to store the mappings of old and new IDs
            let mainClonedElement = null;
        
            function cloneInnerArray(fields, id) {
                fields.forEach(function (element, index) {
                    if (element.id == id) {
                        // Clone element
                        let clonedElement = JSON.parse(JSON.stringify(element));
                        updateElement(clonedElement);
                        fields.splice(index + 1, 0, clonedElement);
        
                        // Save the main cloned element
                        mainClonedElement = fields[index + 1];
                    }
                    else if (element.nodes && element.nodes.length > 0) {
                        cloneInnerArray(element.nodes, id);
                    }
                });
            }
        
            function updateElement(element) {
                let oldId = element.id
                let newId = Math.random().toString(36).substr(2, 9);
                element.id = newId;
                idMappings[oldId] = newId; // Save old and new Id
                delete element.$$hashKey;
                if (element.nodes && Array.isArray(element.nodes)) {
                    element.nodes.forEach(updateElement);
                }
            }
        
            this.pages.forEach(function (page) {
                cloneInnerArray(page.fields, id);
            });

            function walkProperties(obj) {
                if (obj && typeof obj === "object") {
                    Object.keys(obj).forEach(key => {
                        if (typeof obj[key] === "string") {
                            if (idMappings[obj[key]] !== undefined) {
                                obj[key] = idMappings[obj[key]];
                            }
                        } else if (Array.isArray(obj[key])) {
                            obj[key].forEach(el => {
                                if (typeof el === "object") {
                                    walkProperties(el);
                                }
                            });
                        } else if (typeof obj[key] === "object") {
                            walkProperties(obj[key]);
                        }
                    });
                }
            }
            
            // Replace old Id in clone elements
            if (mainClonedElement) {
                walkProperties(mainClonedElement);
            }
        },
        addElementToEnd: function (element) {
            let clonedElement = JSON.parse(JSON.stringify(element));
            delete clonedElement.$$hashKey;
            clonedElement.id = Math.random().toString(36).substr(2, 9);
            this.pages[this.pages.length - 1].fields.push(clonedElement);
        },
        changeElementType: function (elementId, newElement) {
            let foundAndUpdatedElement = null;

            const mergeDefaults = (target, source) => {
                if (typeof target !== 'object' || target === null || Array.isArray(target)) {
                    return JSON.parse(JSON.stringify(source)); 
                }
                for (const key in source) {
                    if (source.hasOwnProperty(key)) {
                        if (key === 'type' || key === 'label') {
                            continue; 
                        }
                        if (typeof source[key] === 'object' && source[key] !== null && !Array.isArray(source[key])) {
                            if (typeof target[key] !== 'object' || target[key] === null || Array.isArray(target[key])) {
                                target[key] = {};
                            }
                            mergeDefaults(target[key], source[key]);
                        } else {
                            if (!target.hasOwnProperty(key) || target[key] === undefined) { 
                                target[key] = source[key];
                            }
                        }
                    }
                }
                return target;
            };
            const findAndClone = (elementsArray) => {
                for (let i = 0; i < elementsArray.length; i++) {
                    let element = elementsArray[i]; 

                    if (element.id === elementId) {
                        let clonedElement = JSON.parse(JSON.stringify(element));
                        clonedElement.type = newElement.type;
                        clonedElement.label = newElement.label;
                        mergeDefaults(clonedElement, newElement);
                        clonedElement.id = elementId; 
                        delete clonedElement.$$hashKey;
                        return clonedElement;
                    }
                    if (element.nodes && element.nodes.length > 0) {
                        const foundInNested = findAndClone(element.nodes);
                        if (foundInNested) {
                            return foundInNested;
                        }
                    }
                }
                return null;
            };
            for (let i = 0; i < this.pages.length; i++) {
                foundAndUpdatedElement = findAndClone(this.pages[i].fields);
                if (foundAndUpdatedElement) {
                    break;
                }
            }
            return foundAndUpdatedElement;
        },
        replaceElement: function (elementId, newElement) {
            const findAndReplaceInternal = (elementsArray) => {
                for (let i = 0; i < elementsArray.length; i++) {
                    let element = elementsArray[i];
                    if (element.id === elementId) {
                        elementsArray[i] = JSON.parse(JSON.stringify(newElement));
                        elementsArray[i].id = elementId; 
                        return true;
                    }
                    if (element.nodes && element.nodes.length > 0) {
                        if (findAndReplaceInternal(element.nodes)) {
                            return true;
                        }
                    }
                }
                return false;
            };
            for (let i = 0; i < this.pages.length; i++) {
                if (findAndReplaceInternal(this.pages[i].fields)) {
                    return true;
                }
            }
            return false;
        }
    };

    return {
        newForm: function (departmentId) {
            var temp = Object.create(form);
            temp.departmentId = departmentId;
            temp.validate_instances = 0;
            temp.addPage();
            return temp;
        },
        loadForm: function (data) {
            var temp = Object.create(form);
            angular.extend(temp, data);

            return temp;
        }
    };
};